<template>
  <div class="rebackPwd-content">
    <el-dialog title="忘记密码" :visible.sync="dialogVisiable" class="reset-dialog" width="500px">
      <el-form :model="rebackPwdForm" label-width="0px" :rules="rebackRules" ref="rebackPwdForm">
        <el-form-item prop="mobile">
          <p>绑定账号</p>
          <el-row :gutter="20">
            <el-col :span="16" :xs="24">
              <el-input type="password" style="position:fixed;bottom:-999px"></el-input>
              <el-input
                v-model.trim="rebackPwdForm.mobile"
                autocomplete="off"
                :maxlength="11"
                size="middle"
              ></el-input>
            </el-col>
            <el-col :span="8" :xs="24" class="submitpasswordBtn">
              <el-button
                @click="sendVerify"
                plain
                size="middle"
                type="primary"
                :disabled="isSendVerify"
              >{{showContent}}</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item prop="smsCode">
          <el-input type="password" style="position:fixed;bottom:-999px"></el-input>
          <el-input
            v-model.trim="rebackPwdForm.smsCode"
            autocomplete="off"
            placeholder="请输入验证码"
            size="middle"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" style="position:fixed;bottom:-999px"></el-input>
          <el-input
            v-model.trim="rebackPwdForm.password"
            type="password"
            autocomplete="off"
            placeholder="请输入新管理密码"
            size="middle"
          ></el-input>
        </el-form-item>
        <el-form-item prop="reckeckPwd">
          <el-input
            v-model.trim="rebackPwdForm.reckeckPwd"
            type="password"
            autocomplete="off"
            size="middle"
            placeholder="请确认管理密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="saveOperate('rebackPwdForm')" class="save-btn" type="primary">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/api/index.js";
export default {
  props: ["isShowDialog"],
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        if (this.rebackPwdForm.secondPassword !== "") {
          this.$refs.rebackPwdForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.rebackPwdForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      dialogVisiable: false,
      url: "http://www.58ln.cn/bkvito",
      isSendVerify: false,
      showContent: "发送验证",
      rebackPwdForm: {
        mobile: "",
        smsCode: "",
        password: "",
        reckeckPwd: ""
      },
      rebackRules: {
        mobile: [{ required: true, message: "请输入账号", trigger: "blur" }],
        smsCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
        reckeckPwd: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  watch: {
    isShowDialog(newValue, oldValue) {
      this.dialogVisiable = true;
      return newValue;
    }
  },
  methods: {
    //发送验证
    async sendVerify() {
      if (!this.rebackPwdForm.mobile) {
        this.$message.error("请输入正确的账号");
        return;
      }
      let res = await this.$http.get(
        `${this.url}${api.getCode}?mobile=${this.rebackPwdForm.mobile}&type=login`
      );
      if (res && res.isSucceed) {
        this.isSendVerify = true;
        this.showContent = 60;
        let timer = setInterval(() => {
          this.showContent--;
          if (this.showContent === 0) {
            clearInterval(timer);
            this.isSendVerify = false;
            this.showContent = "重新发送";
          }
        }, 1000);
      }
    },
    // 忘记密码保存
    saveOperate(formName) {
      this.$refs[formName].validate(async valid => {
        if (!valid) return false;
        let res = await this.$http.post(
          this.url + api.rebackPwd,
          this.$qs.stringify(this.rebackPwdForm)
        );
        if (res && res.code===200) {
          this.$message({
            message: "保存成功",
            type: "success"
          });
          this.dialogVisiable = false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.rebackPwd-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
<style lang="less">
.rebackPwd-content {
  .el-dialog__wrapper {
    overflow: hidden;
  }
  .reset-dialog {
    .el-dialog {
      padding: 40px 80px 20px 80px;
      border-radius: 8px;
      .el-input__inner {
        height: 32px;
        line-height: 32px;
        border: none;
        border-bottom: 1px solid #ccc;
        border-radius: 0;
        padding: 0;
        font-size: 16px;
      }
      .el-dialog__header {
        text-align: left;
        padding: 0px 20px 20px 0;
        .el-dialog__headerbtn,
        .el-dialog__title {
          font-size: 24px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: #333;
        }
        .el-dialog__headerbtn {
          position: absolute;
          top: 40px;
          right: 80px;
        }
      }

      .el-dialog__body {
        height: 300px;
        padding: 0;
        p {
          height: 24px;
          text-align: left;
          font-size: 12px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }
        .el-col-8 {
          .el-button:hover,
          .el-button {
            width: 100%;
            height: 37px;
            border-radius: 4px;
            border: 1px solid #69cc96;
            color: #69cc96;
            background: #fff;
            padding: 12px 0px;
          }
        }
      }
      .el-dialog__footer {
        padding: 20px 0 20px 0;
        .el-button {
          width: 104px;
          height: 40px;
          text-align: center;
          font-size: 16px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: #fff;
          background: #69cc96;
          border: none;
        }
      }
    }
  }
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    -webkit-text-fill-color: #333;
  }
}
</style>